
export default class HistoryService {
  get() {
    return [];
  }

  subscribe(callback) {
    callback([]);
    return ()=>{};
  }

  static build(args) {
    return new HistoryService(args);
  }
}
